import React from 'react';

import css from './FormGroup.module.scss';

interface Props {
    title?: string;
    children: React.ReactNode;
}

const FormGroup: React.FC<Props> = ({ title, children }) => (
    <fieldset className={css.fieldset}>
        {title && <legend className={css.legend}>{title}</legend>}
        {children}
    </fieldset>
);

export default React.memo(FormGroup);
